import { render, staticRenderFns } from "./marketPrice_page.vue?vue&type=template&id=1c0a8f44&scoped=true"
import script from "./marketPrice_page.vue?vue&type=script&lang=js"
export * from "./marketPrice_page.vue?vue&type=script&lang=js"
import style0 from "./marketPrice_page.vue?vue&type=style&index=0&id=1c0a8f44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a8f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0a8f44')) {
      api.createRecord('1c0a8f44', component.options)
    } else {
      api.reload('1c0a8f44', component.options)
    }
    module.hot.accept("./marketPrice_page.vue?vue&type=template&id=1c0a8f44&scoped=true", function () {
      api.rerender('1c0a8f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/marketPrice_page.vue"
export default component.exports